import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { MatterDate } from '../../../models/matter-date';

import { AlertService } from '../../../services/common/alert.service';
import { MatterDateService } from '../../../services/matters/matter-date.service';

@Component({
  selector: 'app-matter-date-index',
  templateUrl: './matter-date-index.component.html',
  styleUrls: ['./matter-date-index.component.css'],
})
export class MatterDateIndexComponent implements OnInit {
  @Input() matter_id: number;

  matter_dates: Array<MatterDate> = [];

  search_params: any = {};

  loading: boolean = true;

  showNewDateForm: boolean = false;

  matterDateToBeDeleted: MatterDate | null;

  constructor(private alertService: AlertService, private matterDateService: MatterDateService, private modalService: NgbModal) {}

  ngOnInit() {
    if (this.matter_id) this.loadMatterDates();
  }

  loadMatterDates() {
    this.search_params.matter_id = this.matter_id;
    this.matterDateService.getMatterDates(this.search_params).then((response_json) => {
      this.loading = false;
      this.matter_dates = response_json;
    });
  }

  editMatterDate(matter_date: MatterDate) {
    matter_date.editing = true;
  }

  formResult(event: any, matter_date: MatterDate | null = null) {
    if (event == 'Form Cancelled') {
      if (matter_date) matter_date.editing = false;
      else this.showNewDateForm = false;
    } else if (event == 'Form Saved') {
      if (matter_date) matter_date.editing = false;
      else this.showNewDateForm = false;
      this.loadMatterDates();
    }
  }

  confirmMatterDateDelete(matter_date: MatterDate, modal: any) {
    this.matterDateToBeDeleted = matter_date;
    this.modalService.open(modal).result.then(
      (result) => {
        this.deleteMatterDate();
      },
      (reason) => {}
    );
  }

  deleteMatterDate() {
    this.matterDateToBeDeleted!.deleting = true;
    let scope = this;
    this.matterDateService
      .deleteMatterDate(this.matterDateToBeDeleted!)
      .then((response_json) => {
        this.matterDateToBeDeleted!.deleting = false;
        this.matterDateToBeDeleted = null;
        if (response_json.text == 'Matter date deleted') {
          this.loadMatterDates();
          this.alertService.alert_status_success(response_json.text);
        } else this.alertService.alert_status_danger(response_json.text || 'Error deleting matter date');
      })
      .catch(function () {
        scope.alertService.alert_status_danger('Error deleting matter date');
        scope.matterDateToBeDeleted!.deleting = false;
        scope.matterDateToBeDeleted = null;
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
